/**
 * Чистые UI-хелперы (без JSX/компонентов). Вынесены в отдельный модуль, чтобы
 * файл с компонентами (ui.tsx → StatusPill) не нарушал react-refresh
 * (only-export-components). Без состояния и зависимостей от React.
 */
import type { SocketStatus } from '../ws';

/** Буквенные метки вариантов (A–H), как в Kahoot. Индексы вне диапазона → число. */
export const OPTION_LABELS = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'] as const;

export function optionLabel(i: number): string {
  return OPTION_LABELS[i] ?? String(i + 1);
}

/** Форматирует 6-значный PIN с пробелом посередине (413 412) для удобства диктовки. */
export function formatPin(pin: string): string {
  return pin.length === 6 ? `${pin.slice(0, 3)} ${pin.slice(3)}` : pin;
}

/**
 * URL, который кодируется в QR: корень сайта с `?pin=`. При сканировании игрок
 * попадает на главную с предзаполненным PIN (и автопереходом к вводу ника).
 */
export function buildJoinUrl(pin: string): string {
  const base =
    typeof window !== 'undefined' && typeof window.location?.origin === 'string'
      ? window.location.origin
      : '';
  return `${base}/?pin=${encodeURIComponent(pin)}`;
}

/**
 * Ключ i18n для подписи статуса соединения. Сам текст берётся из каталога
 * (`status.*`) компонентом StatusPill; здесь — лишь стабильный суффикс ключа.
 * 'idle' (ожидание соединения) маппится на 'waiting'.
 */
export function statusKey(status: SocketStatus): string {
  return status === 'idle' ? 'waiting' : status;
}
